module.exports = exports.default = Object.freeze({
    // Viewport actions
    SET_VIEWPORT: 'SET_VIEWPORT',
    SET_VIEWPORT_OVERLAY: 'SET_VIEWPORT_OVERLAY',
    SET_VIEWPORT_TITLE: 'SET_VIEWPORT_TITLE',

    // Scroll module
    SET_PENDING_AUTOSCROLL: 'SET_PENDING_AUTOSCROLL',
    LOCK_SCROLL: 'LOCK_SCROLL',
    UNLOCK_SCROLL: 'UNLOCK_SCROLL',

    // Modal actions
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    RESET_MODAL: 'RESET_MODAL',
    SET_MODAL_READY: 'SET_MODAL_READY',

    // Video card reducer
    VIDEO_CARD_LOADED: 'VIDEO_CARD_LOADED',
    VIDEO_CARD_RESET: 'VIDEO_CARD_RESET',

    // Set main content
    SET_MAIN_CONTENT_LOADING: 'SET_MAIN_CONTENT_LOADING',
    SET_MAIN_CONTENT_LOADER_VISIBILITY: 'SET_MAIN_CONTENT_LOADER_VISIBILITY',


    // Subscription events
    SET_SUBSCRIPTION_EMAIL: 'SET_SUBSCRIPTION_EMAIL',
    SET_IS_FETCHING_SUBSCRIPTION: 'SET_IS_FETCHING_SUBSCRIPTION',

    // User actions
    DO_AUTOLOGIN: 'DO_AUTOLOGIN',
    SET_IS_UPDATING_ADDRESS: 'SET_IS_UPDATING_ADDRESS',
    SET_USER_AUTHENTICATION: 'SET_USER_AUTHENTICATION',
    SET_USER_FAVORITE_PRODUCTS: 'SET_USER_FAVORITE_PRODUCTS',
    SET_USER_MOST_PURCHASED_PRODUCTS: 'SET_USER_MOST_PURCHASED_PRODUCTS',
    SET_USER_LAST_PURCHASED_PRODUCTS: 'SET_USER_LAST_PURCHASED_PRODUCTS',
    SET_USER_CREDITCARDINFO: 'SET_USER_CREDITCARDINFO',
    SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES: 'SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES',
    SET_USER_FETCHING_CREDITCARDINFO: 'SET_USER_FETCHING_CREDITCARDINFO',

    // addresses
    SET_ORDER_ADDRESS: 'SET_ORDER_ADDRESS',
    SET_USER_ADDRESSES: 'SET_USER_ADDRESSES',
    SET_DEFAULT_ADDRESS: 'SET_DEFAULT_ADDRESS',
    SET_IS_FETCHING_USER_ADDRESSES: 'SET_IS_FETCHING_USER_ADDRESSES',

    // Region
    SET_IS_FETCHING_REGION: 'SET_IS_FETCHING_REGION',
    SET_REGION: 'SET_REGION',
    RESET_REQUESTED_REGION: 'RESET_REQUESTED_REGION',

    // Cart Actions
    SET_IS_FETCHING_CART: 'SET_IS_FETCHING_CART',
    REPLACE_CART: 'REPLACE_CART',
    RESET_CART: 'RESET_CART',
    SET_CART_DRAGGING_TUTORIAL: 'SET_CART_DRAGGING_TUTORIAL',
    SET_CART_TOOLTIP_ID: 'SET_CART_TOOLTIP_ID',
    SET_CART_TEMP_ITEM: 'SET_CART_TEMP_ITEM',
    SET_CART_ERROR: 'SET_CART_ERROR',
    SET_CART_PRODUCT_ERROR: 'SET_CART_PRODUCT_ERROR',
    SET_BLOCKED_CART: 'SET_BLOCKED_CART',
    SET_CART_FOOTER_FIXED: 'SET_CART_FOOTER_FIXED',

    // Products actions
    FETCH_PRODUCTS_BY_CATEGORY: 'FETCH_PRODUCTS_BY_CATEGORY',
    SET_IS_FETCHING_PRODUCTS: 'SET_IS_FETCHING_PRODUCTS',
    FLUSH_PRODUCTS: 'FLUSH_PRODUCTS',

    // Single product actions
    SET_PRODUCT: 'SET_PRODUCT',
    RESET_PRODUCT: 'RESET_PRODUCT',
    SET_IS_FETCHING_PRODUCT: 'SET_IS_FETCHING_PRODUCT',

    // Top-Products actions
    FETCH_TOP_PRODUCTS_BY_CATEGORY: 'FETCH_TOP_PRODUCTS_BY_CATEGORY',
    SET_IS_FETCHING_TOP_PRODUCTS: 'SET_IS_FETCHING_TOP_PRODUCTS',

    // Categories actions
    SET_IS_FETCHING_CATEGORIES: 'SET_IS_FETCHING_CATEGORIES',
    FETCH_CATEGORIES: 'FETCH_CATEGORIES',
    SET_ACTIVE_CATEGORY: 'SET_ACTIVE_CATEGORY',
    SET_CATEGORIES_COOPERATIVE: 'SET_CATEGORIES_COOPERATIVE',
    SET_ACTIVE_LEAF_CATEGORY: 'SET_ACTIVE_LEAF_CATEGORY', // the leaf nodes are the ones with no children
    SET_CATEGORIES_VISIBILITY: 'SET_CATEGORIES_VISIBILITY', // the leaf nodes are the ones with no children

    // Router actions
    SET_ROUTE: 'SET_ROUTE',
    SET_LAST_ROUTE: 'SET_LAST_ROUTE',
    SET_ROUTE_COOPERATIVE: 'SET_ROUTE_COOPERATIVE',
    SET_FORCE_NOT_FOUND: 'SET_FORCE_NOT_FOUND',

    // Header actions
    SET_HEADER_HEIGHT: 'SET_HEADER_HEIGHT',
    SET_HEADER_FACET: 'SET_HEADER_FACET',

    // Menu actions
    OPEN_PANEL: 'OPEN_PANEL',
    CLOSE_PANEL: 'CLOSE_PANEL',
    RESET_PANEL: 'RESET_PANEL',

    // Tooltip
    SET_TOOLTIP_BLOCKER: 'SET_TOOLTIP_BLOCKER',
    SET_TOOLTIPS: 'SET_TOOLTIPS',

    // Checkout
    SET_CHECKOUT_MESSAGE: 'SET_CHECKOUT_MESSAGE',
    SET_CHECKOUT_COMPLETE: 'SET_CHECKOUT_COMPLETE',
    SET_CHECKOUT_VALIDATION: 'SET_CHECKOUT_VALIDATION',
    SET_CHECKOUT_EXCLUDED_PICKERS: 'SET_CHECKOUT_EXCLUDED_PICKERS',
    RESET_CHECKOUT: 'RESET_CHECKOUT',
    TOGGLE_CHECKOUT_ERRORS_VISIBILITY: 'TOGGLE_CHECKOUT_ERRORS_VISIBILITY',
    IS_SUBMITTING_CHECKOUT: 'IS_SUBMITTING_CHECKOUT',
    SET_CHECKOUT_IS_UPDATING_DELIVERY_ADDRESS: 'SET_CHECKOUT_IS_UPDATING_DELIVERY_ADDRESS',
    SET_CHECKOUT_DELIVERY_DATES: 'SET_CHECKOUT_DELIVERY_DATES',
    SET_CHECKOUT_PAYMENT_VALID: 'SET_CHECKOUT_PAYMENT_VALID',
    IS_SUBMITTING_PROMOCODE: 'IS_SUBMITTING_PROMOCODE',

    // Delivery
    SET_DELIVERY_STATE: 'SET_DELIVERY_STATE',
    SET_IS_FETCHING_DELIVERY: 'SET_IS_FETCHING_DELIVERY',
    SET_DELIVERY_STATUS: 'SET_DELIVERY_STATUS',
    RESET_DELIVERY: 'RESET_DELIVERY',

    // Breadcrumbs
    RESET_BREADCRUMBS: 'RESET_BREADCRUMBS',
    SET_BREADCRUMBS: 'SET_BREADCRUMBS',
    ADD_BREADCRUMB: 'ADD_BREADCRUMB',
    REMOVE_BREADCRUMB: 'REMOVE_BREADCRUMB',

    // Notifications
    SET_IS_FETCHING_NOTIFICATIONS: 'SET_IS_FETCHING_NOTIFICATIONS',
    SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
    ADD_NOTIFICATION: 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
    RESET_NOTIFICATIONS: 'RESET_NOTIFICATIONS',

    // Snackbar
    ADD_SNACKBAR_NOTIFICATION: 'ADD_SNACKBAR_NOTIFICATION',
    REMOVE_SNACKBAR_NOTIFICATION: 'REMOVE_SNACKBAR_NOTIFICATION',

    // Poll
    SET_POLLING_ID: 'SET_POLLING_ID',

    //Order History
    FETCH_FINISHED_ORDERS: 'FETCH_FINISHED_ORDERS',
    FETCH_ORDER: 'FETCH_ORDER',
    FETCH_PENDING_ORDERS: 'FETCH_PENDING_ORDERS',
    RESET_ORDERS: 'RESET_ORDERS',
    SET_FEEDBACK: 'SET_FEEDBACK',
    SET_PICKER_RATING: 'SET_PICKER_RATING',

    // Pickers in checkout
    SET_PICKERS: 'SET_PICKERS',
    SET_PICKERS_TOTAL: 'SET_PICKERS_TOTAL',
    SET_PICKERS_LOADED_CHUNK_INDEXES: 'SET_PICKERS_LOADED_CHUNK_INDEXES',
    SET_IS_FETCHING_PICKERS: 'SET_IS_FETCHING_PICKERS',
    SET_PICKER_EXCLUDED: 'SET_PICKER_EXCLUDED',
    SET_PICKERS_TOTAL_CHUNKS: 'SET_PICKERS_TOTAL_CHUNKS',
    SET_PICKERS_ALL_CHUNKS_LOADED: 'SET_PICKERS_ALL_CHUNKS_LOADED',

    // Search stuff
    SET_IS_FETCHING_SEARCH_WORDS: 'SET_IS_FETCHING_SEARCH_WORDS',
    SET_IS_FETCHING_SEARCH_PRODUCTS: 'SET_IS_FETCHING_SEARCH_PRODUCTS',
    SET_SEARCH_PRODUCTS: 'SET_SEARCH_PRODUCTS',
    SET_SEARCH_WORDS: 'SET_SEARCH_WORDS',
    RESET_SEARCH_PRODUCTS: 'RESET_SEARCH_PRODUCTS',
    RESET_SEARCH_WORDS: 'RESET_SEARCH_WORDS',
    RESET_SEARCH: 'RESET_SEARCH',
    SET_COMMON_CATEGORIES: 'SET_COMMON_CATEGORIES',
    SET_IS_LOADING_MORE: 'SET_IS_LOADING_MORE',
    SET_IS_SEARCHING: 'SET_IS_SEARCHING',
    SET_SEARCH_IS_ACTIVE: 'SET_SEARCH_IS_ACTIVE',
    SET_SEARCH_IS_INACTIVE: 'SET_SEARCH_IS_INACTIVE',
    SET_SEARCH_LIMIT: 'SET_SEARCH_LIMIT',
    SET_SEARCH_OFFSET: 'SET_SEARCH_OFFSET',
    SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
    SET_SEARCH_TERM: 'SET_SEARCH_TERM',
    SET_SEARCH_FUZZY: 'SET_SEARCH_FUZZY',

    // Navigator events
    SET_NAVIGATOR_ONLINE: 'SET_NAVIGATOR_ONLINE',

    STRIPE_SET_ERROR: 'STRIPE_SET_ERROR',
    STRIPE_IS_FETCHING: 'STRIPE_IS_FETCHING',


    MYMIGROS_SET_SLIDERS: 'MYMIGROS_SET_SLIDERS',
    MYMIGROS_SET_IS_FETCHING: 'MYMIGROS_SET_IS_FETCHING',
    MYMIGROS_SET_HAS_FETCHED: 'MYMIGROS_SET_HAS_FETCHED',
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/actions-types.js